var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUtenzeB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99999 8.66667C9.99999 5.35296 12.6863 2.66667 16 2.66667C19.3137 2.66667 22 5.35296 22 8.66667C22 11.9804 19.3137 14.6667 16 14.6667C12.6863 14.6667 9.99999 11.9804 9.99999 8.66667ZM8.33333 25C8.33333 20.7658 11.7658 17.3333 16 17.3333C20.2342 17.3333 23.6667 20.7658 23.6667 25V28.3333C23.6667 28.8856 23.2189 29.3333 22.6667 29.3333H9.33333C8.78104 29.3333 8.33333 28.8856 8.33333 28.3333V25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtenzeB);
export default __webpack_public_path__ + "static/media/utenzeB.71ca4fc7d8aa9827963b2569d0b962c1.svg";
export { ForwardRef as ReactComponent };